module.exports = new __parcel__URL__("lego.aa2fe116.webp").toString();